






























































import { defineComponent, onMounted, onUnmounted } from '@vue/composition-api';
import { useRouter } from '../../../composables/use-router';
import { useI18N } from '../../../composables/use-vue-i18n';
import { useAsset } from '../../../plugins/assets';
import { useConfigurationApi } from '../../../plugins/configuration';
import {
  useMobileBehaviour, useNavigationData, useSearch,
} from './SideNavigationFeatures';
import SideNavigationGroup from './SideNavigationGroup.vue';
import SideNavigationQuickMenu from './SideNavigationQuickMenu.vue';
import { useLabelTranslation } from './SideNavigationUtils';
import i18next from 'i18next';
import { useStore } from '../../../store';

export default defineComponent({
  name: 'SideNavigation',
  components: {
    SideNavigationGroup,
    SideNavigationQuickMenu,
  },
  setup() {
    const asset = useAsset();
    const i18n = useI18N();
    const configPlugin = useConfigurationApi();
    const data = configPlugin.data;
    const store = useStore();
    const router = useRouter();
    const {
      getSubPath,
      getFirstLevelMenu,
      getProfileMenu,
      fetchNavigation,
      isProfileMenuRoute,
      state,
      getters,
    } = useNavigationData(
      data,
      {
        routeTerritory: configPlugin.getRouteTerritory(),
        routeLanguage: configPlugin.getRouteLanguage(),
      },
    );

    const translateLabel = useLabelTranslation(i18n);

    const {
      hideMobileMenu, isShowingOnMobile, isShowingBackdrop, initMobileEvents, removeMobileEvents,
    } = useMobileBehaviour();

    const { openSearch, removeSearchEvents } = useSearch({
      onSearchOpen: () => isShowingBackdrop.value = false,
      onSearchHide: () => {
        // restore backdrop only when mobile menu is opened
        if (isShowingOnMobile.value) {
          isShowingBackdrop.value = true;
        }
      },
    });

    onMounted(() => {
      initMobileEvents();
      state.isLoading = true;

      router.router.onReady(async () => {
        const subpath = getSubPath(router.router);

        try {
          if (subpath !== undefined) {
            await fetchNavigation(subpath);

            state.isLoading = false;
          } else {
            state.navigation = isProfileMenuRoute(router.route.value)
              ? getProfileMenu(router.router)
              : getFirstLevelMenu(
                router.router,
                store.getters['auth/isLoggedIn'],
              );

            state.isLoading = false;
          }
        } catch (error) {
          throw new Error(error);
        }
      });
    });

    onUnmounted(() => {
      removeMobileEvents();
      removeSearchEvents();
    });

    return {
      asset,
      i18n,
      state,
      getters,
      isShowingOnMobile,
      isShowingBackdrop,
      hideMobileMenu,
      openSearch,
      translateLabel,
    };
  },
});
